/**
 * Форматирует строку телефона формата 9999999999 в формат +7 (999) 999-99-99
 * @param phone
 */
export const formatPhoneStringToClient = (phone: string): string => {
  return phone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 ($1) $2-$3-$4');
};

/**
 * Форматирует строку телефона формата +79999999999/79999999999 в формат 9999999999
 * @param phone
 */
export const formatPhoneStringToInput = (phone?: string | null): string => {
  if (!phone) {
    return '';
  }

  const phoneDigits = phone.replace(/\D/g, ''); // Удаляем все нецифровые символы
  if (phoneDigits.length === 11 && phoneDigits.startsWith('7')) {
    return phoneDigits.slice(1); // Убираем первую цифру '7'
  }

  return phoneDigits;
};

/**
 * Проверяет валидность номера телефона (должно быть ровно 10 цифр)
 * @param phone
 */
export const isPhoneValid = (phone: string): boolean => {
  const phoneDigits = phone.replace(/\D/g, ''); // Удаляем все нецифровые символы

  return phoneDigits.length === 10; // Проверяем, что осталось ровно 10 цифр
};
